import React, { useEffect, useState } from "react";
import { Grid, Box, Typography } from "@mui/material";
import "./EditSkillModal.css";
import CustomModal from "../../../CustomModal/CustomModal";
import ModalFooter from "../../../CustomModal/ModalFooter";
import ModalHeader from "../../../CustomModal/ModalHeader";
import CustomTextField from "../../../../components/CustomTextField/CustomTextField";
import * as _ from "lodash";
import Compdirection from "../../../../themes/CompDirection";

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  callBackSetEditSkill: (data: string) => void;
  editedSkillName: string;
  trans?: any;
}

const EditSkillModal = ({
  isModalOpen,
  closeModal,
  editedSkillName,
  callBackSetEditSkill,
  trans,
}: ModalProps) => {
  const [skillName, setSkillName] = useState(editedSkillName);

  const handleSubmit = () => {
    closeModal();
    callBackSetEditSkill(skillName);
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="264px"
      modalWidth="600px"
    >
      <ModalHeader
        modal={{ modal_title: trans("Edit Skills") }}
        closeModal={closeModal}
      />
      <Grid
        container
        spacing={2}
        style={{
          marginTop: "20px",
        }}
      >
        <Grid item xs={12}>
          <Compdirection>
            <CustomTextField
              type="string"
              label={trans("Skills")}
              placeholder={trans("Write skills here")}
              value={skillName}
              onChange={(e: any) => setSkillName(e.target.value)}
            />
          </Compdirection>
        </Grid>
      </Grid>
      <Box style={{ marginTop: "35px" }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default EditSkillModal;
